import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { Table, Select, Spin, Modal, Form, DatePicker, Button } from "antd";
import {
	CheckCircleFilled,
	ExclamationCircleFilled,
	CloseOutlined,
	HistoryOutlined,
	CalendarOutlined,
	EditOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import { message } from "antd";
import { CALL_FEATCH_API } from "common/API";
import { useSelector } from "react-redux";
import { get } from "lodash";
import FundRequestModal from "../organisms/FundRequestModal";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import MarkAsPaidPage from "./MarkAsPaidPage";
import { useFetch } from "hooks/useFetch";
import queryKeys from "common/queryKey";
import { currencySymbolMap } from "common/Constants";
import COLORS from "common/Colors";
import { ReactComponent as Editicon } from "../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../assets/Trash_Full.svg";
import { ReactComponent as FilterIcon } from "../assets/filter-svgrepo-com (2).svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import moment from "moment";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

/* ═══════════════════════════════════════════════════════
   STYLED COMPONENTS
═══════════════════════════════════════════════════════ */

const markaspaidsendbtn = {
	background: "#deefee",
	border: "none",
	borderRadius: 2,
	color: "#00685F",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontWeight: 500,
	width: "100px",
};

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) { background-color: #fafafa; }
  .normal-column { min-width: 300px; white-space: normal; }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white { background: #f9f9f9; }
  .ant-select-selector { min-width: 150px; }
  .btn-color{
	  color: #00685F !important;
  }
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const FilterBtn = styled.div`
  position: relative;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: #deefee;
  cursor: pointer;
  color: #6b7280;
  flex-shrink: 0;
  transition: border-color 0.2s;
`;

const FilterBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #fff;
`;

const TotalLog = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

const FiltersRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const LoadingWrapper = styled.div`
  display: flex; align-items: center; justify-content: center;
  padding: 60px 0;
`;

const PaidBadge = styled.span`
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 14px; font-weight: 500; color: #15803d;
  .paid-icon { font-size: 15px; color: #16a34a; }
`;

const WaitingText = styled.span`
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 14px; color: #374151;
`;

const IconBtn = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.15s;
`;

/* ── History icon button ── */
const HistoryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #deefee;
  background: #deefee;
  color: #00685F;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  &:hover {
    border: 1px solid #deefee;
  background: #deefee;
  color: #00685F;
  }
`;
const SendBtn = styled.button`
  border-radius: 6px;
  border: 1px solid #deefee;
  background: #deefee;
  color: #00685F;
  cursor: pointer;
  
  &:hover {
    border: 1px solid #deefee;
  background: #deefee;
  color: #00685F;
  }
`;

const StyleddeactivateModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding: 35px 0px 20px 0px;
  }
  .ant-modal-content {
    box-shadow: 0px 0px 8px #00000029;
    border-radius: 10px;
  }
  .ant-modal-title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
  }
  .ant-modal-body { padding: 0px 24px 28px 24px; }
  .ant-modal-close-x { display: none; }
  .ant-modal-footer { display: none; }
`;

const CloneBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 10px;
    background: #00685F;
    border: none;
    color: #ffffff !important;
    font-weight: 600;
    box-shadow: none;
    &:hover, &:focus { background: #00685F !important; color: #ffffff !important; }
  }
`;

const CancelBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 10px;
    border: 1px solid #000000;
    color: #ffffff;
    font-weight: 500;
    box-shadow: none;
    &:hover { border-color: #000000; color: #000000; }
  }
`;

const DropdownWrapper = styled.div`
  width: 150px;
  .custom-filter-btn {
    width: 100% !important;
    margin-bottom: 0 !important;
  }
`;

/* ── Modal overlay & box ── */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 800px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 24px 14px;
  flex-shrink: 0;
  border-bottom: 1px solid #f3f4f6;
`;

const ModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px 0;
`;

const DetailBody = styled.div`
  padding: 0 24px 24px;
  overflow-y: auto;
  flex: 1;
`;

const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
`;

const DetailLabel = styled.span`
  flex: 0 0 40%;
  color: #888;
  font-size: 14px;
  padding-top: 1px;
`;

const DetailValue = styled.span`
  flex: 1;
  font-size: 14px;
  color: #222;
  word-break: break-word;
  white-space: pre-wrap;
`;

const DescriptionBlock = styled.div`
  padding: 12px 0;
`;

const DescriptionLabel = styled.div`
  color: #888;
  font-size: 14px;
  margin-bottom: 6px;
`;

const DescriptionValue = styled.div`
  font-size: 14px;
  color: #222;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
`;

const DeclineReasonBox = styled.div`
  margin-top: 4px;
  padding: 10px 14px;
  background: #fff5f5;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  color: #7f1d1d;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`;

const CreatedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 20px;
  padding: 3px 12px;
  font-weight: 500;
`;

const CloseBtn = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const PaidLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  padding: 0;
  border: none;
  background: transparent;
  color: #2563eb;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-underline-offset: 2px;
  &:hover { color: #1d4ed8; }
`;

/* ── Payment History Modal Styles ── */
const HistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;
const HistoryTh = styled.th`
  text-align: left;
  padding: 10px 14px;
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 1.5px solid #e5e7eb;
`;
const HistoryTd = styled.td`
  padding: 12px 14px;
  color: #374151;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
`;

/* ── Send page ── */
const PageBreadcrumb = styled.div`
  display: flex; align-items: center; gap: 8px;
  padding-bottom: 12px;
  font-size: 14px; color: #6b7280;
  span.active { color: #111827; font-weight: 600; }
`;

const PageContent = styled.div`padding: 28px 32px;`;

const PageFooter = styled.div`
  display: flex; align-items: center; justify-content: flex-end;
  gap: 12px; padding: 20px 32px; border-top: 1px solid #f3f4f6;
`;

const SendFormGrid = styled.div`
  display: grid; grid-template-columns: 120px 1fr; gap: 16px;
  align-items: start; margin-bottom: 6px;
`;

const SendLabel = styled.label`
  font-size: 14px; color: #374151; font-weight: 400; padding-top: 10px; line-height: 1;
`;

const SendInput = styled.input`
  width: 100%; height: 40px; padding: 0 14px;
  border: 1px solid #e5e7eb; border-radius: 8px;
  outline: none; box-sizing: border-box;
  background: ${({ readOnly }) => readOnly ? "#f9fafb" : "#fff"};
  transition: border-color 0.15s;
  &:focus { border-color: #0d9488; }
  &::placeholder { color: #9ca3af; }
`;

const SendTextarea = styled.textarea`
  width: 100%; min-height: 96px; padding: 10px 14px;
  border: 1px solid #e5e7eb; border-radius: 8px;
  outline: none; resize: vertical; box-sizing: border-box;
  transition: border-color 0.15s;
  &:focus { border-color: #0d9488; }
  &::placeholder { color: #9ca3af; }
`;

/* ═══════════════════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════════════════ */

function getCurrencySymbol(currency) {
	return currencySymbolMap[currency] ?? currency ?? "";
}

/* ═══════════════════════════════════════════════════════
   STATUS HELPERS
═══════════════════════════════════════════════════════ */

const STATUS = {
	WAITING: "waiting",
	APPROVED: "approved",
	DECLINED: "declined",
	PAID: "paid",
};

function normalizeStatus(record) {
	const raw = (record.status || record.statusType || "").toLowerCase().trim();
	if (raw.includes("waiting") || raw.includes("approval")) return STATUS.WAITING;
	if (raw.includes("paid")) return STATUS.PAID;
	if (raw.includes("approved")) return STATUS.APPROVED;
	if (raw.includes("declined") || raw.includes("rejected")) return STATUS.DECLINED;
	return raw;
}

function formatDate(dateStr) {
	if (!dateStr) return "–";
	const date = new Date(dateStr);
	if (isNaN(date)) return dateStr;
	const day = date.getDate();
	const suffix =
		day % 10 === 1 && day !== 11 ? "st" :
			day % 10 === 2 && day !== 12 ? "nd" :
				day % 10 === 3 && day !== 13 ? "rd" : "th";
	const month = date.toLocaleDateString("en-GB", { month: "short" });
	const year = date.getFullYear();
	return `${day}${suffix} ${month} ${year}`;
}

function resolveNames(emailsOrIds, userList, currentUserId = "") {
	if (!Array.isArray(emailsOrIds) || !emailsOrIds.length) return "---";
	return emailsOrIds
		.map((val) => {
			if (!val) return "—";
			if (currentUserId && val?.toLowerCase() === currentUserId?.toLowerCase()) return "You";
			const user = userList?.find(
				(u) => u?.email === val || u?.userid === val || u?.emailid === val
			);
			return user?.fullname || user?.firstname || val;
		})
		.join(", ");
}

/* ═══════════════════════════════════════════════════════
   PAYMENT HISTORY MODAL  (standalone, reusable)
═══════════════════════════════════════════════════════ */

function PaymentHistoryModal({ record, open, onClose }) {
	const [historyData, setHistoryData] = useState([]);
	const [historyLoading, setHistoryLoading] = useState(false);

	const displayCurrency = record?.currency ?? "";
	const displayCurrencySymbol = getCurrencySymbol(displayCurrency);

	useEffect(() => {
		if (!open || !record) return;
		const fetchHistory = async () => {
			setHistoryLoading(true);
			setHistoryData([]);
			try {
				const fundId = record?.fundid || record?.id || "";
				const billingId = record?.billingid || record?.billId || "";

				let endpoint = "";
				if (billingId) {
					// billing-module path — try billing history first
					endpoint = `insyts/billing/getbillinghistory?billingid=${billingId}`;
				} else if (fundId) {
					endpoint = `insyts-legal/getfundrequesthistory?fundid=${fundId}`;
				}

				if (!endpoint) {
					message.error("No valid history source found");
					return;
				}

				const res = await CALL_FEATCH_API(endpoint, "GET");
				const rows =
					res?.response?.data ??
					res?.response ??
					res?.data ??
					[];
				setHistoryData(Array.isArray(rows) ? rows : []);
			} catch (err) {
				console.error("Error fetching payment history:", err);
				message.error("Failed to load payment history.");
			} finally {
				setHistoryLoading(false);
			}
		};
		fetchHistory();
	}, [open, record]);

	const totalPaidSoFar = useMemo(() => {
		if (!historyData.length) return null;
		return historyData.reduce(
			(sum, row) => sum + parseFloat(row.AmountMarkedasPaid || row.amountpaid || row.amount || 0),
			0
		);
	}, [historyData]);

	const requestedAmount =
		record?.requestamount || record?.amount || "–";

	return (
		<Modal
			title={null}
			open={open}
			onCancel={onClose}
			footer={null}
			width={760}
			centered
			destroyOnClose
		>
			<div style={{ padding: "4px 0 8px" }}>
				{/* Header row */}
				<div style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					marginBottom: 16,
					paddingRight: 32,
				}}>
					<span style={{ fontSize: 14, fontWeight: 700, color: "#111827", flexShrink: 0 }}>
						Payment History
					</span>
					<span style={{ fontSize: 14, color: "#374151", marginLeft: 16 }}>
						Amount requested initially:{" "}
						<span style={{ color: "#0d9488", fontWeight: 700 }}>
							{displayCurrencySymbol}{requestedAmount}
						</span>
					</span>
				</div>

				{historyLoading ? (
					<div style={{ textAlign: "center", padding: "40px 0" }}>
						<Spin size="default" />
					</div>
				) : historyData.length === 0 ? (
					<div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
						No payment history found.
					</div>
				) : (
					<>
						<HistoryTable>
							<thead>
								<tr>
									<HistoryTh>S.No</HistoryTh>
									<HistoryTh>Amount Marked as Paid</HistoryTh>
									<HistoryTh>Source</HistoryTh>
									<HistoryTh>Destination</HistoryTh>
									<HistoryTh>Marked on</HistoryTh>
									<HistoryTh>Balance</HistoryTh>
								</tr>
							</thead>
							<tbody>
								{historyData.map((row, idx) => (
									<tr key={row.id || row.historyid || idx}>
										<HistoryTd>{idx + 1}</HistoryTd>
										<HistoryTd>
											{getCurrencySymbol(row.currency || displayCurrency)}
											{row.AmountMarkedasPaid ?? row.amountpaid ?? row.amount ?? "–"}
										</HistoryTd>
										<HistoryTd>{row.Source || row.source || row.sourceaccountname || "–"}</HistoryTd>
										<HistoryTd>{row.Destination || row.destination || row.destinationaccountname || "–"}</HistoryTd>
										<HistoryTd>
											<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
												<CalendarOutlined style={{ color: "#9ca3af" }} />
												{formatDate(row.MarkedOn || row.paymentdate || row.markedon || row.createdat)}
											</span>
										</HistoryTd>
										<HistoryTd>
											{row.Balance !== undefined && row.Balance !== null
												? `${getCurrencySymbol(row.currency || displayCurrency)}${row.Balance}`
												: row.balance !== undefined && row.balance !== null
													? `${getCurrencySymbol(row.currency || displayCurrency)}${row.balance}`
													: "–"}
										</HistoryTd>
									</tr>
								))}
							</tbody>
						</HistoryTable>

						{totalPaidSoFar !== null && (
							<div style={{
								display: "flex",
								justifyContent: "flex-end",
								marginTop: 12,
								paddingTop: 10,
								borderTop: "1px solid #f3f4f6",
								fontSize: 14,
								color: "#374151",
							}}>
								Total paid so far:{" "}
								<span style={{ color: "#0d9488", fontWeight: 700, marginLeft: 6 }}>
									{displayCurrencySymbol}{totalPaidSoFar}
								</span>
							</div>
						)}
					</>
				)}
			</div>
		</Modal>
	);
}

/* ═══════════════════════════════════════════════════════
   FUND REQUEST DETAIL MODAL
═══════════════════════════════════════════════════════ */

function FundRequestDetailModal({ record, onClose, onMarkAsPaid, onSend, onDelete, onEdit, userEmail = "" }) {
	const userList = useSelector((store) => get(store, "common.userList", []));
	const userInfo = useSelector((store) => get(store, "common.userInfo", {}));
	const isOwnrequest = String(record.createdby || "").toLowerCase() === String(userInfo?.userid || "").toLowerCase();
	const [historyModalOpen, setHistoryModalOpen] = useState(false);
	const [historyData, setHistoryData] = useState([]);
	const [historyLoading, setHistoryLoading] = useState(false);
	const history = useHistory();
	if (!record) return null;

	const isPaid = record?.paidstatus === 1;
	const status = normalizeStatus(record);

	const displayCurrency = record.currency || "";
	const displayCurrencySymbol = currencySymbolMap[displayCurrency] ?? displayCurrency;

	const parsedPaid = parseFloat(record.amountpaid || record.paidamount || 0);
	const paidBadgeLabel =
		parsedPaid > 0
			? `Paid (${displayCurrencySymbol}${parsedPaid})`
			: null;

	const handleOpenHistory = async () => {
		setHistoryModalOpen(true);
		setHistoryLoading(true);
		try {
			const fundId = record.fundid || record.id || "";
			if (!fundId) {
				message.error("No valid history source found");
				setHistoryData([]);
				return;
			}
			const res = await CALL_FEATCH_API(
				`insyts-legal/getfundrequesthistory?fundid=${fundId}`,
				"GET"
			);
			const rows =
				res?.response?.data ??
				res?.response ??
				res?.data ??
				[];
			setHistoryData(Array.isArray(rows) ? rows : []);
		} catch (err) {
			console.error("Error fetching payment history:", err);
			message.error("Failed to load payment history.");
			setHistoryData([]);
		} finally {
			setHistoryLoading(false);
		}
	};

	const totalPaidSoFar = historyData.length
		? historyData.reduce(
			(sum, row) =>
				sum + parseFloat(row.AmountMarkedasPaid || row.amountpaid || row.amount || 0),
			0
		)
		: null;

	return (
		<>
			<Overlay onClick={onClose}>
				<ModalBox onClick={(e) => e.stopPropagation()}>

					<ModalHeader>
						<div style={{ flex: 1, minWidth: 0 }}>
							<ModalTitle>
								Fund Request{" "}
								<span style={{ fontWeight: 400, color: "#555" }}>
									({record.fundid || record.id})
								</span>
							</ModalTitle>

							<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
								<CreatedBadge>
									<b>Created by:</b>&nbsp;
									{(() => {
										const name = resolveNames([record.createdby], userList, userEmail);
										const date =
											record.createdat || record.createddate
												? moment(record.createdat || record.createddate).format("Do MMM, YYYY")
												: "";
										return `${name}${date ? "; " + date : ""}`;
									})()}
								</CreatedBadge>

								{status === STATUS.APPROVED && (
									<span style={{
										display: "inline-flex", alignItems: "center", gap: 4,
										background: "#e6f9f0", color: "#1a4731",
										fontSize: 12, padding: "3px 12px", borderRadius: 20,
									}}>
										<span style={{ color: "#888", fontWeight: 500 }}>Approved by</span>
										<span style={{ fontWeight: 600 }}>
											{resolveNames([record.approvedby], userList, userEmail)}
										</span>
										{(record.approvedat || record.approveddate) && (
											<span style={{ color: "#888" }}>
												· {formatDate(record.approvedat || record.approveddate)}
											</span>
										)}
									</span>
								)}

								{status === STATUS.DECLINED && (
									<span style={{
										display: "inline-flex", alignItems: "center", gap: 4,
										background: "#fde8e8", color: "#7f1d1d",
										fontSize: 12, padding: "3px 12px", borderRadius: 20,
									}}>
										<span style={{ color: "#888", fontWeight: 400 }}>Declined by</span>
										<span style={{ fontWeight: 600 }}>
											{resolveNames([record.declinedby], userList, userEmail)}
										</span>
										{(record.declinedat || record.declineddate) && (
											<span style={{ color: "#888" }}>
												· {formatDate(record.declinedat || record.declineddate)}
											</span>
										)}
									</span>
								)}
							</div>
						</div>
						<div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0, marginLeft: 16 }}>
							{(status === STATUS.WAITING && isOwnrequest) && (
								<>
									<EditOutlined style={{
										color: "#00685F",
										cursor: "pointer",
										background: "#deefee",
										padding: "2px",
										borderRadius: "4px",
										height: "25px",
										width: "25px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: 18
									}}
										onClick={(e) => { e.stopPropagation(); onClose(); onEdit(record); }}
									/>
									{!(record.balance > 0) && (
										<TrashDelete
											onClick={(e) => { e.stopPropagation(); onDelete(record); onClose(); }}
											style={{
												color: "#00685F",
												cursor: "pointer",
												background: "#deefee",
												padding: "2px",
												borderRadius: "4px",
												height: "25px",
												width: "25px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												fontSize: 18
											}}
										/>
									)}
								</>
							)}
							{status === STATUS.APPROVED && !isPaid && (
								<>
									<SendBtn
										style={{ fontSize: 14, height: 34, padding: "0 16px" }}
										onClick={(e) => { e.stopPropagation(); onClose(); onSend(record); }}
									>
										Send
									</SendBtn>
									<HistoryBtn
										style={markaspaidsendbtn}
										className="btn-color"

										// style={{ fontSize: 14, height: 34, padding: "0 16px" }}
										onClick={(e) => {
											e.stopPropagation(); onClose();
											onMarkAsPaid(record);
										}}
									>
										Mark as Paid
									</HistoryBtn>
								</>
							)}
							<CloseBtn onClick={onClose}><CloseOutlined /></CloseBtn>
						</div>
					</ModalHeader>
					<DetailBody>
						{[
							["Client", record.clientname || record.client],
							["Request Type", record.requestfundtype || record.requesttype],
							["Due Date", formatDate(record.duedate)],
							["Status", record.status],
							["Matter", record.matter === " " ? "–" : (record.mattername || record.matter)],
						].map(([label, value]) => (
							<DetailRow key={label}>
								<DetailLabel>{label}</DetailLabel>
								<DetailValue>{value || "–"}</DetailValue>
							</DetailRow>
						))}

						<DetailRow>
							<DetailLabel>Amount</DetailLabel>
							<DetailValue style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: 6 }}>
								<span>
									{(() => {
										const amount = record.balance > 0
											? record.balance
											: record.requestamount ?? record.amount ?? "–";
										const symbol = currencySymbolMap[record.currency] ?? record.currency ?? "$";
										return amount !== "–" ? `${symbol} ${amount}` : "–";
									})()}
								</span>

								{paidBadgeLabel && (
									<PaidLink
										onClick={(e) => {
											e.stopPropagation();
											handleOpenHistory();
										}}
									>
										{paidBadgeLabel}
									</PaidLink>
								)}
							</DetailValue>
						</DetailRow>

						<DescriptionBlock>
							<DescriptionLabel>Description</DescriptionLabel>
							<DescriptionValue>{record.description || "–"}</DescriptionValue>
						</DescriptionBlock>

						{status === STATUS.DECLINED && (record.declinedreason || record.declinedReason) && (
							<DescriptionBlock style={{ paddingTop: 0 }}>
								<DescriptionLabel style={{ color: "#b91c1c" }}>Reason for Decline</DescriptionLabel>
								<DeclineReasonBox>
									{record.declinedreason || record.declinedReason}
								</DeclineReasonBox>
							</DescriptionBlock>
						)}
					</DetailBody>

				</ModalBox>
			</Overlay>
			<Modal
				title={null}
				open={historyModalOpen}
				onCancel={() => setHistoryModalOpen(false)}
				footer={null}
				width={760}
				centered
				destroyOnClose
			>
				<div style={{ padding: "4px 0 8px" }}>
					<div style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						marginBottom: 16,
						paddingRight: 32,
					}}>
						<span style={{ fontSize: 14, fontWeight: 700, color: "#111827", flexShrink: 0 }}>
							Payment History
						</span>
						<span style={{ fontSize: 14, color: "#374151", marginLeft: 16 }}>
							Amount requested initially:{" "}
							<span style={{ color: "#0d9488", fontWeight: 700 }}>
								{displayCurrencySymbol}
								{record.requestamount || record.amount || "–"}
							</span>
						</span>
					</div>

					{historyLoading ? (
						<div style={{ textAlign: "center", padding: "40px 0" }}>
							<Spin size="default" />
						</div>
					) : historyData.length === 0 ? (
						<div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
							No payment history found.
						</div>
					) : (
						<>
							<HistoryTable>
								<thead>
									<tr>
										<HistoryTh>S.No</HistoryTh>
										<HistoryTh>Amount Marked as Paid</HistoryTh>
										<HistoryTh>Source</HistoryTh>
										<HistoryTh>Destination</HistoryTh>
										<HistoryTh>Marked on</HistoryTh>
										<HistoryTh>Balance</HistoryTh>
									</tr>
								</thead>
								<tbody>
									{historyData.map((row, idx) => (
										<tr key={row.id || row.historyid || idx}>
											<HistoryTd>{idx + 1}</HistoryTd>
											<HistoryTd>
												{currencySymbolMap[row.currency || displayCurrency] ?? row.currency ?? ""}
												{row.AmountMarkedasPaid ?? row.amountpaid ?? row.amount ?? "–"}
											</HistoryTd>
											<HistoryTd>{row.Source || row.source || row.sourceaccountname || "–"}</HistoryTd>
											<HistoryTd>{row.Destination || row.destination || row.destinationaccountname || "–"}</HistoryTd>
											<HistoryTd>
												<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
													{formatDate(row.MarkedOn || row.paymentdate || row.markedon || row.createdat)}
												</span>
											</HistoryTd>
											<HistoryTd>
												{row.Balance != null
													? `${currencySymbolMap[row.currency || displayCurrency] ?? ""}${row.Balance}`
													: row.balance != null
														? `${currencySymbolMap[row.currency || displayCurrency] ?? ""}${row.balance}`
														: "–"}
											</HistoryTd>
										</tr>
									))}
								</tbody>
							</HistoryTable>
							{totalPaidSoFar !== null && (
								<div style={{
									display: "flex",
									justifyContent: "flex-end",
									marginTop: 12,
									paddingTop: 10,
									borderTop: "1px solid #f3f4f6",
									fontSize: 14,
									color: "#374151",
								}}>
									Total paid so far:{" "}
									<span style={{ color: "#0d9488", fontWeight: 700, marginLeft: 6 }}>
										{displayCurrencySymbol}{totalPaidSoFar}
									</span>
								</div>
							)}
						</>
					)}
				</div>
			</Modal>
		</>
	);
}

/* ═══════════════════════════════════════════════════════
   SENDING BILL PAGE
═══════════════════════════════════════════════════════ */

function SendingBillPage({ record, onBack, onSuccess }) {
	const userList = useSelector((store) => get(store, "common.userList", []));

	const userName = useMemo(() => {
		if (!record?.useremail) return "";
		const user = userList?.find(
			(u) =>
				u?.email?.toLowerCase() === record.useremail?.toLowerCase() ||
				u?.userid?.toLowerCase() === record.useremail?.toLowerCase() ||
				u?.emailid?.toLowerCase() === record.useremail?.toLowerCase()
		);
		return user?.fullname || user?.firstname || user?.name || "";
	}, [userList, record?.useremail]);

	const name =
		record?.mattername || record?.matter || record?.client || "Matter";

	const id =
		record?.matterid || record?.id;

	const hasValidId = id !== undefined && id !== null && id !== " ";

	const [subject, setSubject] = useState(
		`Fund request for ${name}${hasValidId ? ` (${id})` : ""}`
	);
	const [footer, setFooter] = useState(`Regards,\n${userName || record?.useremail || ""}`);
	const [cc, setCc] = useState("");
	const [body, setBody] = useState("");
	const [title, setTitle] = useState(record?.clientname || record?.client || "");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (userName) {
			setFooter((prev) => {
				if (prev === `Regards,\n${record?.useremail || ""}`) {
					return `Regards,\n${userName}`;
				}
				return prev;
			});
		}
	}, [userName]);

	const handleSendMail = async () => {
		try {
			setLoading(true);
			const payload = {
				title, subject,
				to: [...new Set([record?.primarycontactemail, record?.responsiblePersonnelemails]
					?.filter(Boolean))]
					?.join(", ") || "–",
				cc, body, footer,
				senderName: userName || record?.useremail || "",
				requestType: record?.requesttype,
				matter: record?.matter,
				amount: record?.amount,
				dueDate: record?.duedate,
				currency: currencySymbolMap[record.currency] ?? record?.currency ?? "USD",
			};
			const response = await CALL_FEATCH_API("insyts-legal/sendfundrequestmail", "post", payload);
			if (response?.status === 200 || response?.status === "SUCCESS" || response?.code === "SUCCESS") {
				message.success("Mail sent successfully ✅");
				onSuccess();
			} else {
				message.error(response?.message || "Failed to send mail ❌");
			}
		} catch (err) {
			console.error("Send mail error:", err);
			message.error("Something went wrong while sending mail ❌");
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<PageBreadcrumb>
				<span onClick={onBack} style={{ cursor: "pointer", color: "#0d9488", fontWeight: 500 }}>Back</span>
				<span><NavigateNextIcon fontSize="small" /></span>
				<span className="active">Sending Fund request</span>
			</PageBreadcrumb>
			<PageContent>
				<div style={{ fontSize: 16, fontWeight: 700, marginBottom: 24 }}>
					Client: {record?.clientname || record?.client || "–"}
				</div>
				<div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
					<SendFormGrid><SendLabel>Title:</SendLabel><SendInput value={title} onChange={(e) => setTitle(e.target.value)} /></SendFormGrid>
					<SendFormGrid><SendLabel>Subject:</SendLabel><SendInput value={subject} onChange={(e) => setSubject(e.target.value)} /></SendFormGrid>
					<SendFormGrid><SendLabel>To:</SendLabel><SendInput disabled value={[...new Set([record?.primarycontactemail, record?.responsiblePersonnelemails]
						?.filter(Boolean))]
						?.join(", ") || "–"} /></SendFormGrid>
					<SendFormGrid><SendLabel>CC:</SendLabel><SendInput value={cc} onChange={(e) => setCc(e.target.value)} /></SendFormGrid>
					<SendFormGrid><SendLabel>Body:</SendLabel><SendTextarea value={body} onChange={(e) => setBody(e.target.value)} /></SendFormGrid>
					<SendFormGrid><SendLabel>Footer:</SendLabel><SendTextarea value={footer} onChange={(e) => setFooter(e.target.value)} rows={3} /></SendFormGrid>
				</div>
			</PageContent>
			<PageFooter>
				<ButtonOutlined onClick={onBack}>Cancel</ButtonOutlined>
				<ButtonFilled onClick={handleSendMail} disabled={loading}>
					{loading ? "Sending..." : "Send Mail"}
				</ButtonFilled>
			</PageFooter>
		</>
	);
}

/* ═══════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════ */

export default function FundRequestTab({
	markAsPaidRecord: markAsPaidRecordProp,
	onMarkAsPaidChange,
	sendRecord: sendRecordProp,
	onSendRecordChange,
	page,
}) {
	const userInfo = useSelector((store) => get(store, "common.userInfo"));
	const userList = useSelector((store) => get(store, "common.userList", []));
	const userEmail = userInfo?.email || userInfo?.userid || "";

	const clientId = useMemo(() => {
		const segments = window.location.pathname.split("/");
		const idx = segments.findIndex((s) => s === "client-detail");
		return idx !== -1 && segments[idx + 1] ? segments[idx + 1] : null;
	}, []);

	const [filterModalOpen, setFilterModalOpen] = useState(false);
	const [filterForm] = Form.useForm();
	const [dateFilterCount, setDateFilterCount] = useState(0);
	const [hoveredRow, setHoveredRow] = useState(null);
	const [form] = Form.useForm();
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [pendingDeleteRecord, setPendingDeleteRecord] = useState(null);

	const [filterOptions, setFilterOptions] = useState({
		clients: [],
		requestTypes: [],
		matters: [],
		statuses: []
	});

	/* ── Payment history state ── */
	const [historyRecord, setHistoryRecord] = useState(null);
	const [historyModalOpen, setHistoryModalOpen] = useState(false);

	const openHistory = (record) => {
		setHistoryRecord(record);
		setHistoryModalOpen(true);
	};
	const closeHistory = () => {
		setHistoryModalOpen(false);
		setHistoryRecord(null);
	};

	const allDataRef = useRef([]);

	const [markAsPaidRecordLocal, setMarkAsPaidRecordLocal] = useState(null);
	const [sendRecordLocal, setSendRecordLocal] = useState(null);

	const markAsPaidRecord = onMarkAsPaidChange ? markAsPaidRecordProp : markAsPaidRecordLocal;
	const setMarkAsPaidRecord = onMarkAsPaidChange ? onMarkAsPaidChange : setMarkAsPaidRecordLocal;
	const sendRecord = onSendRecordChange ? sendRecordProp : sendRecordLocal;
	const setSendRecord = onSendRecordChange ? onSendRecordChange : setSendRecordLocal;

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [deletingId, setDeletingId] = useState(null);
	const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

	const { getAllClientList } = queryKeys;
	const { data: clientData } = useFetch(getAllClientList.key, getAllClientList.url);
	const clientList = clientData?.response?.data ?? [];

	const history = useHistory();

	const clientEmailMap = useMemo(() => {
		const map = {};
		clientList.forEach((c) => {
			map[c.bdo_id] = {
				primarycontactemail: c.primarycontactemail || "",
			};
		});
		return map;
	}, [clientList]);

	// Replace fetchAndSend with this
	const handleSend = useCallback(async (record) => {
		const matterId = record?.matterid;
		let matterData = null;



		const emailLookup = clientEmailMap[record?.clientid] || {};

		setSendRecord({
			...record,
			useremail: userEmail,
			primarycontactemail: emailLookup?.primarycontactemail || record?.primarycontactemail || "",
			...(matterData ? { responsiblePersonnelemails: matterData?.responsiblePersonnel?.map((p) => p.emailid)?.join(", ") } : {}),
		});
	}, [queryKeys, clientEmailMap, userEmail, setSendRecord]);

	const [clientFilter, setClientFilter] = useState([]);
	const [requestTypeFilter, setRequestTypeFilter] = useState([]);
	const [matterFilter, setMatterFilter] = useState([]);
	const [statusFilter, setStatusFilter] = useState([]);
	const [isFiltered, setIsFiltered] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);
	const [editRecord, setEditRecord] = useState(null);
	const [detailRecord, setDetailRecord] = useState(null);
	const [dueRangeValue, setDueRangeValue] = useState(null);

	const [activeDateFilters, setActiveDateFilters] = useState({
		createdfrom: "",
		createdto: "",
		duefrom: "",
		dueto: "",
	});

	const containerRef = useRef(null);

	useEffect(() => {
		if (userEmail) fetchFundRequests(1, pagination.pageSize);
	}, [userEmail]);

	const params = new URLSearchParams();
	if (page !== "client") {
		params.set("userid", userEmail);
	}
	if (page === "client") {
		params.set("clientid", clientId);
	}

	const { key: getFundRequestFilterListKey, url: getFundRequestFilterListUrl } =
		queryKeys.getFundRequestFilterList(
			`?${params.toString()}`
		);

	const { data: filterData } = useFetch(
		getFundRequestFilterListKey,
		getFundRequestFilterListUrl,
		{ enabled: !!userEmail }
	);

	useEffect(() => {
		const d = filterData?.response?.data;
		if (!d) return;

		setFilterOptions({
			clients: (d.clients || [])
				.map((c) => ({ label: c.clientname, value: c.clientname }))
				.filter((c) => c.label?.trim()),

			requestTypes: (d.requesttypes || [])
				.map((r) => ({ label: r, value: r }))
				.filter(Boolean),

			matters: (d.matters || [])
				.map((m) => ({ label: m.mattername, value: m.mattername }))
				.filter((m) => m.label?.trim() && m.label !== " "),

			statuses: (d.statuses || [])
				.map((s) => ({ label: s, value: s }))
				.filter(Boolean),
		});
	}, [filterData]);

	const fetchFundRequests = useCallback(async (pageNum = 1, pageSize = 10) => {
		if (!userEmail) return;
		try {
			setLoading(true);
			const params = new URLSearchParams();
			if (page !== "client") {
				params.set("userid", userEmail);
			}
			params.set("page", pageNum);
			params.set("limit", pageSize);

			if (page === "client") {
				params.set("clientid", clientId);
			}

			const response = await CALL_FEATCH_API(`insyts-legal/getfundrequest?${params.toString()}`, "get");
			let rows = [], total = 0;
			if (response?.status === "SUCCESS" && Array.isArray(response?.response?.data)) {
				rows = (response.response.data || []).map((item) => ({
					...item,
					primarycontactemail: item.primarycontactemail,
				}));
				total =
					response.response.pagination?.total ??
					response.response.total ??
					rows.length;
			}
			allDataRef.current = rows;
			setData(rows);
			setPagination((prev) => ({ ...prev, current: pageNum, pageSize, total }));
		} catch (err) {
			console.error("Failed to fetch fund requests:", err);
			message.error("Failed to load fund requests.");
		} finally {
			setLoading(false);
		}
	}, [userEmail, clientId, page]);

	const applyFormFilters = useCallback(() => {
		const values = form.getFieldsValue();
		const client = values.client || [];
		const requestType = values.requesttype || [];
		const matter = values.matter || [];
		const status = values.status || [];
		setClientFilter(client);
		setRequestTypeFilter(requestType);
		setMatterFilter(matter);
		setStatusFilter(status);
		const hasAnyFilter = client.length || requestType.length || matter.length || status.length;
		if (hasAnyFilter) {
			applyFiltersAPI(client, requestType, matter, status, 1, pagination.pageSize);
		} else {
			setIsFiltered(false);
			setActiveDateFilters({ createdfrom: "", createdto: "", duefrom: "", dueto: "" });
			setData([...allDataRef.current]);
			setPagination((prev) => ({ ...prev, current: 1 }));
			fetchFundRequests(1, pagination.pageSize);
		}
	}, [form, pagination.pageSize]);

	const applyFiltersAPI = async (
		client = [],
		requestType = [],
		matter = [],
		status = [],
		pageNum = 1,
		pageSize = pagination.pageSize,
		dateFilters = activeDateFilters
	) => {
		try {
			setLoading(true);
			const params = new URLSearchParams();
			params.set("userid", userEmail);
			params.set("page", pageNum);
			params.set("limit", pageSize);

			if (clientId) params.set("clientid", clientId);
			if (client.length) params.set("client", client.join(","));
			if (requestType.length) params.set("requesttype", requestType.join(","));
			if (matter.length) params.set("matter", matter.join(","));
			if (status.length) {
				const statusMap = { waiting: "Waiting for Approval", approved: "Approved", declined: "Declined", paid: "Paid" };
				params.set("status", status.map((s) => statusMap[s] || s).join(","));
			}

			if (dateFilters.createdfrom) params.set("createdfrom", dateFilters.createdfrom);
			if (dateFilters.createdto) params.set("createdto", dateFilters.createdto);
			if (dateFilters.duefrom) params.set("duefrom", dateFilters.duefrom);
			if (dateFilters.dueto) params.set("dueto", dateFilters.dueto);

			const response = await CALL_FEATCH_API(`insyts-legal/getfundrequestfilter?${params.toString()}`, "get");
			const rows = response?.response?.data || response?.data || [];
			const total =
				response?.response?.pagination?.total ??
				response?.pagination?.total ??
				rows.length;

			setData(Array.isArray(rows) ? rows : []);
			setIsFiltered(true);
			setPagination((prev) => ({ ...prev, current: pageNum, pageSize, total }));
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	};

	const applyDateFilters = async () => {
		const values = filterForm.getFieldsValue();
		const createdRange = values.createdrange || [];
		const dueRange = dueRangeValue || [];
		const createdfrom = createdRange[0]?.format("YYYY-MM-DD") || "";
		const createdto = createdRange[1]?.format("YYYY-MM-DD") || "";
		const duefrom = dueRange[0]?.format("YYYY-MM-DD") || "";
		const dueto = dueRange[1]?.format("YYYY-MM-DD") || "";
		const count = (createdRange?.length ? 1 : 0) + (dueRange?.length ? 1 : 0);
		setDateFilterCount(count);

		const newDateFilters = { createdfrom, createdto, duefrom, dueto };
		setActiveDateFilters(newDateFilters);

		setFilterModalOpen(false);

		applyFiltersAPI(clientFilter, requestTypeFilter, matterFilter, statusFilter, 1, pagination.pageSize, newDateFilters);
	};

	const clearDateFilters = () => {
		filterForm.resetFields();
		setDateFilterCount(0);
		setFilterModalOpen(false);
		setDueRangeValue(null);
		setIsFiltered(false);
		setActiveDateFilters({ createdfrom: "", createdto: "", duefrom: "", dueto: "" });
		setPagination((prev) => ({ ...prev, current: 1 }));
		fetchFundRequests(1, pagination.pageSize);
	};

	const requestDelete = (record) => {
		setPendingDeleteRecord(record);
		setDeleteConfirmOpen(true);
	};

	const confirmDelete = async () => {
		const record = pendingDeleteRecord;
		const fundid = record?.fundid || record?.id || record?.key;
		if (!fundid) { message.error("Cannot delete: record ID not found."); return; }
		try {
			setDeletingId(fundid);
			const response = await CALL_FEATCH_API("insyts-legal/deletefundrequest", "delete", { fundid: String(fundid), deletedby: userEmail });
			const success =
				response?.status === 200 || response?.status === "SUCCESS" ||
				response?.code === "SUCCESS" || response?.message?.toLowerCase?.()?.includes("success");
			if (success) {
				message.success("Fund request deleted.");
				fetchFundRequests(pagination.current, pagination.pageSize);
			} else {
				message.error(response?.message || "Failed to delete fund request.");
			}
		} catch (err) {
			console.error("Delete error:", err);
			message.error("Something went wrong while deleting.");
		} finally {
			setDeletingId(null);
			setDeleteConfirmOpen(false);
			setPendingDeleteRecord(null);
		}
	};

	const cancelDelete = () => {
		setDeleteConfirmOpen(false);
		setPendingDeleteRecord(null);
	};

	const handleMarkAsPaidConfirm = () => {
		setMarkAsPaidRecord(null);
		fetchFundRequests(pagination.current, pagination.pageSize);
	};

	if (markAsPaidRecord) {
		return (
			<MarkAsPaidPage
				record={markAsPaidRecord}
				onBack={() => setMarkAsPaidRecord(null)}
				onConfirm={handleMarkAsPaidConfirm}
			/>
		);
	}
	if (sendRecord) {
		return (
			<SendingBillPage
				record={{
					...sendRecord,
					useremail: userEmail,
					primarycontactemail: sendRecord?.primarycontactemail || "",
				}}
				onBack={() => setSendRecord(null)}
				onSuccess={() => setSendRecord(null)}
			/>
		);
	}

	const renderStatus = (record) => {
		const status = normalizeStatus(record);
		if (status === STATUS.WAITING) {
			return <WaitingText>Waiting for Approval</WaitingText>;
		}
		if (status === STATUS.PAID) {
			return <PaidBadge><CheckCircleFilled className="paid-icon" /> Paid</PaidBadge>;
		}
		if (status === STATUS.APPROVED) {
			const name = resolveNames([record.approvedby], userList, userEmail);
			const fullText = `Approved by: ${name}`;
			return (
				<div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<span
						title={fullText}
						style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}
					>
						{fullText}
					</span>
					<span style={{ fontStyle: "italic", fontSize: 12, color: "#6b7280" }}>
						{formatDate(record.approvedat || record.approveddate)}
					</span>
				</div>
			);
		}
		if (status === STATUS.DECLINED) {
			const name = resolveNames([record.declinedby], userList, userEmail);
			const fullText = `Declined by: ${name}`;
			return (
				<div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<span
						title={fullText}
						style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}
					>
						{fullText}
					</span>
					<span style={{ fontSize: 12, color: "#6b7280" }}>
						{formatDate(record.declinedat || record.declineddate || record.approvedat || record.approveddate)}
					</span>
				</div>
			);
		}
		return <span style={{ color: "#9ca3af" }}>{record.status || "–"}</span>;
	};

	const renderAction = (record, index) => {
		const isOwnrequest = String(record.createdby || "").toLowerCase() === String(userInfo?.userid || "").toLowerCase();
		const isPaid = record?.paidstatus === 1;
		const status = normalizeStatus(record);
		const key = record.fundid || record.id || `row-${index}`;
		const isHovered = hoveredRow === key;
		const isDeleting = deletingId === (record.fundid || record.id || key);
		const hasPaidAmount = parseFloat(record?.amountpaid || record?.paidamount || 0) > 0;

		if (isDeleting) {
			return (
				<div style={{ display: "flex", alignItems: "center", gap: 8 }} onClick={(e) => e.stopPropagation()}>
					<Spin size="small" />
					<span style={{ fontSize: 12, color: "#9ca3af" }}>Deleting…</span>
				</div>
			);
		}

		return (
			<div
				style={{
					display: "flex",
					gap: 6,
					alignItems: "center",
					justifyContent: "flex-start",
					opacity: isHovered ? 1 : 0,
					pointerEvents: isHovered ? "auto" : "none",
					transition: "opacity 0.2s ease",
				}}
				onClick={(e) => e.stopPropagation()}
			>
				{/* Mark as Paid — approved, not paid */}
				{status === STATUS.APPROVED && !isPaid && (
					<Button
						size="small"
						style={markaspaidsendbtn}
						className="btn-color"
						onClick={(e) => {
							e.stopPropagation();
							setMarkAsPaidRecord(record);
						}}
					>
						Mark as Paid
					</Button>
				)}

				{/* Send — approved, not paid */}
				{status === STATUS.APPROVED && !isPaid && (
					<Button
						style={markaspaidsendbtn}
						className="btn-color"
						onClick={(e) => {
							e.stopPropagation();
							handleSend(record);
						}}
					>
						Send
					</Button>
				)}

				{/* Paid badge + Send — when fully paid */}
				{isPaid && (
					<>
						<PaidBadge><CheckCircleFilled className="paid-icon" /> Paid</PaidBadge>
						<SendBtn
							style={{ fontSize: 14, height: 34, padding: "0 14px", backgroundColor: "#deefee", color: "#0f766e" }}
							onClick={(e) => { e.stopPropagation(); handleSend(record); }}
						>
							Send
						</SendBtn>
					</>
				)}

				{/* History icon */}
				{hasPaidAmount && (
					<HistoryBtn
						title="View payment history"
						onClick={(e) => { e.stopPropagation(); openHistory(record); }}
					>
						<HistoryOutlined style={{ fontSize: 15 }} />
					</HistoryBtn>
				)}

				{/* Edit / Delete — waiting, own request */}
				{status === STATUS.WAITING && isOwnrequest && (
					<>
						<IconBtn title="Edit" onClick={(e) => { e.stopPropagation(); setEditRecord(record); setModalVisible(true); }}>
							<EditOutlined style={{
								color: "#00685F",
								cursor: "pointer",
								background: "#deefee",
								padding: "2px",
								borderRadius: "4px",
								height: "25px",
								width: "25px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: 18
							}} />
						</IconBtn>
						{record?.balance === null && (
							<IconBtn title="Delete" onClick={(e) => { e.stopPropagation(); requestDelete(record); }}>
								<TrashDelete style={{
									color: "#00685F",
									cursor: "pointer",
									background: "#deefee",
									padding: "2px",
									borderRadius: "4px",
									height: "25px",
									width: "25px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontSize: 18
								}} />
							</IconBtn>
						)}
					</>
				)}
			</div>
		);
	};

	const activeFilterCount = [
		...(clientFilter || []),
		...(requestTypeFilter || []),
		...(matterFilter || []),
		...(statusFilter || []),
	].length;

	const uniqueClients = [...new Set(allDataRef.current.map((d) => d.clientname || d.client).filter(Boolean))];
	const uniqueRequestTypes = [...new Set(allDataRef.current.map((d) => d.requestfundtype || d.requesttype).filter(Boolean))];
	const uniqueMatters = [...new Set(allDataRef.current.map((d) => d.mattername || d.matter).filter(Boolean))];

	const statusOptions = [
		{ label: "Waiting for Approval", value: "waiting" },
		{ label: "Approved", value: "approved" },
		{ label: "Declined", value: "declined" },
		{ label: "Paid", value: "paid" },
	];

	function isOverdue(record) {
		const status = normalizeStatus(record);
		if (status !== STATUS.WAITING) return false;
		const due = record.duedate || record.dueDate;
		if (!due) return false;
		return new Date(due) < new Date();
	}

	const fmt = (v) => {
		const n = parseFloat(v);
		if (isNaN(n)) return v;
		return n % 1 === 0 ? String(Math.trunc(n)) : n.toString();
	};

	const columns = [
		{
			title: "Client", key: "client",
			render: (_, r) => (
				<span title={r.clientname || r.client || "–"} style={{ display: "block", maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
					{r.clientname || r.client || "–"}
				</span>
			),
		},
		{ title: "ID", key: "fundid", render: (_, r) => r.fundid || r.id || "–" },
		{ title: "Req Type", width: 180, key: "requesttype", render: (_, r) => r.requestfundtype || r.requesttype || "–" },
		{
			title: "Matter", key: "matter",
			render: (_, record) => {
				const name = record.mattername || record.matter?.trim();
				const matterId = record.matterid;
				if ((!name && !matterId) || matterId === " ") return <span style={{ color: "#9ca3af" }}>---</span>;
				return (
					<div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
						{name && (
							<span title={name} style={{ display: "block", maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 500 }}>
								{name}
							</span>
						)}
						{matterId && <span style={{ fontSize: 12, color: "#9ca3af" }}>{matterId}</span>}
					</div>
				);
			},
		},
		{
			title: "Amount", key: "amount",
			render: (_, r) => {
				const amount = r.balance > 0 ? r.balance : r.requestamount ?? r.amount ?? "–";
				const symbol = currencySymbolMap[r.currency] ?? r.currency ?? "$";
				return `${symbol} ${amount !== "–" ? fmt(amount) : "–"}`;
			},
		},
		{
			title: "Due Date", key: "dueDate", width: 130,
			render: (_, record) => {
				const overdue = isOverdue(record);
				return (
					<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
						{overdue && <ExclamationCircleFilled style={{ color: "#ef4444", fontSize: 14 }} />}
						<span style={{ fontStyle: overdue ? "italic" : "normal" }}>
							{formatDate(record.duedate || record.dueDate)}
						</span>
					</span>
				);
			},
		},
		{ title: "Status", key: "status", width: 200, render: (_, record) => renderStatus(record) },
		{ title: "", key: "action", width: 280, render: (_, record, index) => renderAction(record, index) },
	];

	return (
		<div ref={containerRef}>
			<Toolbar>
				<TotalLog>Total Log: {pagination.total}</TotalLog>
				<Form form={form} onValuesChange={applyFormFilters} layout="inline">
					<FiltersRight>
						<DropdownWrapper>
							<DropdownCheckBox name="client" label="Client"
								options={filterOptions.clients}
								form={form} handleFormChange={applyFormFilters} />
						</DropdownWrapper>

						<DropdownWrapper>
							<DropdownCheckBox name="requesttype" label="Request Type"
								options={filterOptions.requestTypes}
								form={form} handleFormChange={applyFormFilters} />
						</DropdownWrapper>

						<DropdownWrapper>
							<DropdownCheckBox name="matter" label="Matter"
								options={filterOptions.matters}
								form={form} handleFormChange={applyFormFilters} />
						</DropdownWrapper>
						<DropdownWrapper>
							<DropdownCheckBox name="status" label="Status"
								options={filterOptions.statuses}
								form={form} handleFormChange={applyFormFilters} />
						</DropdownWrapper>
						<FilterBtn onClick={() => setFilterModalOpen(true)} title="Advanced Filters">
							<FilterIcon style={{ cursor: "pointer", fontSize: 20 }} />
							{dateFilterCount > 0 && <FilterBadge>{dateFilterCount}</FilterBadge>}
						</FilterBtn>
						<ButtonFilled onClick={() => { setEditRecord(null); setModalVisible(true); }} style={{ display: page === "client" ? "none" : undefined }}>
							Create Fund Request
						</ButtonFilled>
					</FiltersRight>
				</Form>
			</Toolbar>

			{loading ? (
				<LoadingWrapper><Spin size="large" tip="Loading fund requests..." /></LoadingWrapper>
			) : (
				<StyledTable
					dataSource={data}
					columns={columns}
					pagination={{
						current: pagination.current,
						pageSize: pagination.pageSize,
						total: pagination.total,
						showSizeChanger: false,
						onChange: (page) => {
							setPagination((prev) => ({ ...prev, current: page }));
							if (isFiltered) {
								applyFiltersAPI(clientFilter, requestTypeFilter, matterFilter, statusFilter, page, pagination.pageSize);
							} else {
								fetchFundRequests(page, pagination.pageSize);
							}
						},
					}}
					rowKey={(r, index) => r.fundid || r.id || `row-${index}`}
					onRow={(record, index) => {
						const key = record.fundid || record.id || `row-${index}`;
						return {
							onClick: () => setDetailRecord(record),
							onMouseEnter: () => setHoveredRow(key),
							onMouseLeave: () => setHoveredRow(null),
						};
					}}
					locale={{ emptyText: "No fund requests found." }}
				/>
			)}

			{detailRecord && (
				<FundRequestDetailModal
					record={detailRecord}
					onClose={() => setDetailRecord(null)}
					onMarkAsPaid={(rec) => { setDetailRecord(null); setMarkAsPaidRecord(rec); }}
					onSend={(rec) => { setDetailRecord(null); setSendRecord(rec); }}
					onDelete={(rec) => { setDetailRecord(null); requestDelete(rec); }}
					onEdit={(rec) => { setDetailRecord(null); setEditRecord(rec); setModalVisible(true); }}
					userEmail={userEmail}
				/>
			)}

			{/* ── Payment History Modal (shared) ── */}
			<PaymentHistoryModal
				record={historyRecord}
				open={historyModalOpen}
				onClose={closeHistory}
			/>

			<FundRequestModal
				visible={modalVisible}
				onClose={() => { setModalVisible(false); setEditRecord(null); }}
				editRecord={editRecord}
				onSuccess={() => fetchFundRequests(pagination.current, pagination.pageSize)}
			/>

			<Modal
				open={filterModalOpen}
				onCancel={() => setFilterModalOpen(false)}
				footer={null}
				width={900}
				title={`Filter ${(activeFilterCount + dateFilterCount) > 0 ? `(${activeFilterCount + dateFilterCount})` : ""}`}
				centered
			>
				<div style={{ paddingTop: 8 }}>
					<div style={{ display: "flex", gap: 24, marginBottom: 28, flexWrap: "wrap" }}>
						<div style={{ flex: 1, minWidth: 220 }}>
							<div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Created Date Range</div>
							<Form form={filterForm} layout="vertical">
								<Form.Item name="createdrange">
									<DatePicker.RangePicker allowSameDay style={{ width: "100%", borderRadius: 20, height: 40 }} format="DD-MM-YYYY" />
								</Form.Item>
							</Form>
						</div>
						<div style={{ flex: 1, minWidth: 220 }}>
							<div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Due Date Range</div>
							<DatePicker.RangePicker
								style={{ width: "100%", borderRadius: 20, height: 40 }}
								format="DD-MM-YYYY"
								allowSameDay
								value={dueRangeValue}
								onChange={(val) => {
									setDueRangeValue(val);
									filterForm.setFieldsValue({ duerange: val });
								}}
							/>
						</div>
					</div>
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f3f4f6", paddingTop: 16 }}>
						<ButtonOutlined onClick={clearDateFilters}>Clear All</ButtonOutlined>
						<ButtonFilled onClick={applyDateFilters}>Apply Filter</ButtonFilled>
					</div>
				</div>
			</Modal>

			<StyleddeactivateModal
				open={deleteConfirmOpen}
				onCancel={cancelDelete}
				footer={null}
				width={500}
				closable={false}
				centered
				destroyOnClose
			>
				<div style={{ textAlign: "left", padding: "24px 16px 8px" }}>
					<p style={{ marginBottom: 32 }}>Are you sure you want to delete this Fund Request?</p>
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
						<CancelBtn onClick={cancelDelete} style={{ width: 150, borderRadius: 10 }}>No</CancelBtn>
						<CloneBtn onClick={confirmDelete} style={{ width: 150 }}>Yes</CloneBtn>
					</div>
				</div>
			</StyleddeactivateModal>
		</div>
	);

}